import { Accept } from "react-dropzone";

export interface UploadErrors {
    totalFilesExceeded?: boolean;
    filesTotalSizeExceeded?: string[];
    filesInvalidType?: string[];
    filesInvalidSize?: string[];
    filesUploadFailed?: string[];
    filesDuplicated?: string[];
}

export const defaultUploadErrors: UploadErrors = {
    filesInvalidSize: [],
    filesInvalidType: [],
    filesUploadFailed: [],
    filesTotalSizeExceeded: [],
    filesDuplicated: [],
    totalFilesExceeded: false,
};

export type FileProps = {
    uploadGuid: string;
    type: string;
    name: string;
    size: number;
    path: string;
    preview: string;
    originalFile: any;
};

export type FileUploaderProps = {
    maxNumberOfFiles?: number;
    maxFileSize?: number;
    maxTotalSize?: number;
    allowedFileTypes?: Accept;
};
